<template>
    <div class="main-container">
        <div class="frame">
            <div class="logo" :style="[product == 'cms' ? 
                'height: calc(95 * var(--rpx)); width: calc(190 * var(--rpx));' : 
                'height: calc(140* var(--rpx)); width: calc(120 * var(--rpx));']"></div>
        </div>
        <div class="questions">
            <div class="frame-1">
                <div class="frame-2">
                    <div class="frame-3" @click="scrollToDiv('landing-header')">
                        <span class="create-account">Create account</span>
                    </div>
                </div>
                <div class="frame-4">
                    <div class="frame-5" @click="scrollToDiv('why-prime')">
                        <span class="why-aban-prime">Why {{title}}?</span>
                    </div>
                </div>
                <div class="frame-6">
                    <div class="frame-7" @click="scrollToDiv('how-it-works')">
                        <span class="how-it-works">How it works?</span>
                    </div>
                </div>
            </div>
            <div class="frame-8">
                <span class="copyright-abanprime">Copyright 2023 - 2024 {{website}}. All Rights Reserved</span>
            </div>
        </div>
    </div>
</template>

<script>
import settings from '../../settings';

export default {
    data() {
        return {
            title: settings.PRODUCT_TITLE,
            website: settings.PRODUCT_WEBSITE,
            product: settings.PRODUCT
        }
    },
    name: 'LandingFooter',
    methods: {
        scrollToDiv(divId) {
            const element = document.getElementById(divId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }
}
</script>

<style scoped>
.main-container {
    overflow: hidden;
}

.main-container,
.main-container * {
    box-sizing: border-box;
}

input,
select,
textarea,
button {
    outline: 0;
}

.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    gap: calc(24 * var(--rpx));
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: calc(32 * var(--rpx)) calc(24 * var(--rpx)) calc(7 * var(--rpx)) calc(24 * var(--rpx));
    background: linear-gradient(180deg, #d5e6ff, #dde6f2);
}

.frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(8 * var(--rpx));
    position: relative;
    width: calc(118.00000762939453 * var(--rpx));
}

.logo {
    flex-shrink: 0;
    position: relative;
    background: url(@/assets/icons/logo-under-title.svg) no-repeat center;
    background-size: cover;
    z-index: 1;
    overflow: hidden;
}

.aban-prime {
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    height: calc(25 * var(--rpx));
    color: #0e2546;
    font-family: Public Sans, var(--default-font-family);
    font-size: calc(21.125808715820312 * var(--rpx));
    font-weight: 700;
    line-height: calc(24.822824478149414 * var(--rpx));
    text-align: left;
    white-space: nowrap;
    z-index: 2;
}

.questions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(32 * var(--rpx));
    position: relative;
    width: calc(382 * var(--rpx));
    padding: calc(8 * var(--rpx)) 0 0 0;
    z-index: 3;
}

.frame-1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(7 * var(--rpx));
    position: relative;
    width: calc(206 * var(--rpx));
    z-index: 4;
}

.frame-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(16 * var(--rpx));
    position: relative;
    width: calc(206 * var(--rpx));
    z-index: 5;
}

.frame-3 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(10 * var(--rpx));
    position: relative;
    width: calc(130 * var(--rpx));
    padding: calc(4 * var(--rpx)) 0 calc(4 * var(--rpx)) 0;
    z-index: 6;
}

.create-account {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    width: calc(130 * var(--rpx));
    height: calc(20 * var(--rpx));
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 600;
    line-height: calc(20 * var(--rpx));
    text-align: center;
    white-space: nowrap;
    z-index: 7;
}

.frame-4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(16 * var(--rpx));
    position: relative;
    width: calc(206 * var(--rpx));
    z-index: 8;
}

.frame-5 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(10 * var(--rpx));
    position: relative;
    width: calc(130 * var(--rpx));
    padding: calc(4 * var(--rpx)) 0 calc(4 * var(--rpx)) 0;
    z-index: 9;
}

.why-aban-prime {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    width: calc(130 * var(--rpx));
    height: calc(20 * var(--rpx));
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 600;
    line-height: calc(20 * var(--rpx));
    text-align: center;
    white-space: nowrap;
    z-index: 10;
}

.frame-6 {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(16 * var(--rpx));
    position: relative;
    width: calc(206 * var(--rpx));
    z-index: 11;
}

.frame-7 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(10 * var(--rpx));
    position: relative;
    width: calc(130 * var(--rpx));
    padding: calc(4 * var(--rpx)) 0 calc(4 * var(--rpx)) 0;
    z-index: 12;
}

.how-it-works {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    width: calc(130 * var(--rpx));
    height: calc(20 * var(--rpx));
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 600;
    line-height: calc(20 * var(--rpx));
    text-align: center;
    white-space: nowrap;
    z-index: 13;
}

.frame-8 {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(10 * var(--rpx));
    position: relative;
    min-width: 0;
    padding: calc(12 * var(--rpx)) 0 0 0;
    border-top: calc(0.5 * var(--rpx)) solid #6c6b6b;
    z-index: 14;
}

.copyright-abanprime {
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    height: calc(16 * var(--rpx));
    color: #444a54;
    font-family: dana, var(--default-font-family);
    font-size: calc(12 * var(--rpx));
    font-weight: 300;
    line-height: calc(16 * var(--rpx));
    text-align: left;
    white-space: nowrap;
    z-index: 15;
}
</style>